// components/BotonAgregarPago.js
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const BotonAgregarPago = ({ onClick, disabled }) => {
  return (
    <Button
      variant="contained"
      color="success"
      startIcon={<AddIcon />}
      onClick={onClick}
      disabled={disabled}
      sx={{ mb: 2 }}
    >
      Agregar Pago
    </Button>
  );
};